/* cj-card-quick-add.js, bug audit fix 3 (4 Nov 2026; Sandra 3 Nov: phones get a "Quick add" bar under every product
   card photo that opens the existing quick view). snippets/product-grid-item.liquid renders the bar (phones and small
   tablets, medium-up--hide) and loads this file as a module from every card, so the browser runs it once. The theme keeps
   its card quick view desktop only (theme.initQuickShop skips the mobile breakpoint; the card's opener ships small--hide),
   so a tap loads that card's modal body the way cj-rec-quick-add does on the PDP row, lifts the modal to <body> (inside a
   card it opens trapped) and clicks the card's own opener: the modal is the theme's, with its swatches, sizes and Add to
   cart. A load that fails does nothing: the page never moves (her MQV rule, 19 Sep). */
const ONMS = /\.myshopify\.com$/i.test(location.hostname);

/* the PDP "You May Also Like" row has its own phone Quick view bar (cj-rec-quick-add): one control per card there */
const css = document.createElement('style');
css.textContent = '.grid-product:has(.cj-rqa-qv) .cj-qa-bar{display:none!important}.cj-qa-bar[aria-busy="true"]{opacity:.7}';
document.head.appendChild(css);

function qs() {
  let q = ONMS ? '&_fd=0' : '';
  try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') q += '&preview_theme_id=' + Shopify.theme.id; } catch (x) {}
  return q;
}

function lift(id) {
  const m = document.getElementById('QuickShopModal-' + id);
  if (m && m.parentNode !== document.body) document.body.appendChild(m);
}

const jobs = {};
function load(handle, id) {
  if (jobs[id]) return jobs[id];
  const home = (window.theme && window.theme.routes && window.theme.routes.home) || '';
  const url = (home + '/products/' + handle + '?view=modal' + qs()).replace('//', '/');
  jobs[id] = fetch(url).then(function (r) { return r.text(); }).then(function (text) {
    const box = document.createElement('div');
    box.innerHTML = text;
    const div = box.querySelector('.product-section[data-product-handle="' + handle + '"]');
    const holder = document.getElementById('QuickShopHolder-' + handle);
    const T = window.theme;
    if (!div || !holder || !T || !T.Modals || !T.sections || !T.Product) { jobs[id] = null; return false; }
    lift(id);
    holder.innerHTML = '';
    holder.appendChild(div);
    new T.Modals('QuickShopModal-' + id, 'quick-modal-' + id);
    T.sections.register('product', T.Product, holder);
    if (T.collapsibles) T.collapsibles.init();
    return true;
  }).catch(function () { jobs[id] = null; return false; });
  return jobs[id];
}

document.addEventListener('click', function (e) {
  const b = e.target && e.target.closest && e.target.closest('.cj-qa-bar');
  if (!b) return;
  e.preventDefault();
  e.stopPropagation();
  const card = b.closest('.grid-product');
  if (!card || b.getAttribute('aria-busy') === 'true') return;
  /* colour cards (cj-colour-cards) carry data-cjcc-pid; clicking their opener lets cj-colour-cards.js pick the card's colour */
  const id = card.getAttribute('data-product-id') || card.getAttribute('data-cjcc-pid'), handle = card.getAttribute('data-product-handle');
  const opener = card.querySelector('.js-modal-open-quick-modal-' + id);
  if (!id || !handle || !opener) return;
  const holder = document.getElementById('QuickShopHolder-' + handle);
  /* already loaded, by us or by the theme's own desktop hover: just open it */
  if (card.__cjqa || (holder && holder.querySelector('.product-section'))) { card.__cjqa = true; lift(id); opener.click(); return; }
  b.setAttribute('aria-busy', 'true');
  load(handle, id).then(function (ok) {
    b.removeAttribute('aria-busy');
    if (ok) { card.__cjqa = true; lift(id); opener.click(); }
  });
});
